export default "__VITE_PUBLIC_ASSET__ae795055__"